module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      class: {
        expanded: _vm.showChildren(item),
        parent: item.groupId
      },
      style: ([{
        'border-color': _vm.iconColor
      }])
    }, [_c('a', {
      staticClass: "nav-item",
      class: {
        external: item.isExternal,
        'close-panel': !_vm.hasChildren(item),
      },
      attrs: {
        "target": item.isExternal ? '_blank' : null,
        "data-panel": "left"
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(item, $event)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.getIconClass(item.iconId),
      style: ({
        color: _vm.iconColor
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "text",
      style: ({
        color: _vm.fontColor
      })
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (_vm.hasChildren(item)) ? _c('span', {
      staticClass: "list-arrow",
      style: ({
        'border-left-color': _vm.fontColor
      })
    }) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "expand",
        "duration": 1000
      }
    }, [_c('ListMenu', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showChildren(item)),
        expression: "showChildren(item)"
      }],
      staticClass: "inner-list",
      attrs: {
        "items": item.children,
        "iconColor": _vm.iconColor,
        "fontColor": _vm.fontColor
      },
      on: {
        "onClick": function($event) {
          return _vm.onClick($event)
        }
      }
    })], 1)], 1)
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0511a97a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0511a97a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/list-menu-component.vue
// module id = 779
// module chunks = 0